import { createListenerMiddleware, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@vision/ui/interfaces';
import { AuthService } from '@vision/ui/services';
import { activityTracker } from '@vision/ui/utils';
import { refetchNotificationsAction } from '../actions';
import { changeSelectedAccountAction, logoutAction } from '../states';

export const ListenerMiddleware = createListenerMiddleware();

/*
* Burada dispatch edilen farklı "action" lar dinlenebilir ve istenilen side effect koşulabilir
*
ListenerMiddleware.startListening({
  actionCreator: action1,
  effect: async (action, listenerApi) => {
    // Custom logic
  },
});

ListenerMiddleware.startListening({
  actionCreator: action2,
  effect: async (action, listenerApi) => {
    // Custom logic
  },
});
* */

ListenerMiddleware.startListening({
  actionCreator: changeSelectedAccountAction,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(refetchNotificationsAction(action.payload));
  },
});

ListenerMiddleware.startListening({
  matcher: isAnyOf(
    AuthService.endpoints.login.matchFulfilled,
    AuthService.endpoints.authenticate.matchFulfilled,
    AuthService.endpoints.validateOtp.matchFulfilled,
  ),
  effect: async (action, listenerApi) => {
    const user = (action as PayloadAction<User>).payload;
    if (user?.session_timeout_in_minutes) {
      activityTracker.start(user.session_timeout_in_minutes, () => {
        listenerApi.dispatch(
          AuthService.endpoints.authenticate.initiate({ id: user.id, token: user.token }, { forceRefetch: true }),
        );
      });
    }
  },
});

ListenerMiddleware.startListening({
  actionCreator: logoutAction,
  effect: async () => {
    activityTracker.stop();
  },
});
